import React, { Suspense } from "react";
import "./App.css";
import Routes from "./router";
import { AuthProvider } from "./hooks/useAuth";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { KeyExchangeApiProvider } from "./network/KeyExchangeWrapper";
import { locationConfig } from "./constants/config";
import { LocationProvider } from "./features/location/context/locationContext";
import { ThemeProvider } from "./theme/ThemeProvider";

function App() {
  return (
    <div className="App h-screen no-scrollbar">
      <ThemeProvider>
        <LocationProvider apiKey={locationConfig.apiKey}>
          <Suspense fallback={<div>Loading...</div>}>
            <Router window={window}>
              <AuthProvider>
                <Provider store={store}>
                  <KeyExchangeApiProvider>
                    <Routes />
                  </KeyExchangeApiProvider>
                </Provider>
              </AuthProvider>
            </Router>
          </Suspense>
        </LocationProvider>
      </ThemeProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
